import type { FunctionPlugin } from 'vue';

const ActualitesPlugin: FunctionPlugin = function () {
  // Nothing to do for now
  //
  // See https://vuejs.org/v2/guide/plugins.html#Writing-a-Plugin
};

export default ActualitesPlugin;
